import React from 'react';
import clsx from 'clsx';
import { Drawer, SwipeableDrawer, useMediaQuery } from '@mui/material';

import FusePageSimpleSidebarContent, { type FusePageSimpleSidebarContentProps } from './FusePageSimpleSidebarContent';

type FusePageSimpleSidebarProps = {
	open: boolean;
	onClose?: () => void;
	position: 'left' | 'right';
	sidebarWidth: number;
} & FusePageSimpleSidebarContentProps;

const FusePageSimpleSidebar = React.forwardRef(({ open = true, ...props }: FusePageSimpleSidebarProps, ref) => {
	const { onClose, position, sidebarWidth, variant } = props;
	const isLgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

	const [isOpen, setIsOpen] = React.useState(open);

	React.useImperativeHandle(ref, () => ({
		toggleSidebar: handleToggleDrawer
	}));

	const handleToggleDrawer = React.useCallback(val => {
		setIsOpen(val);
	}, []);

	React.useEffect(() => {
		handleToggleDrawer(open);
	}, [handleToggleDrawer, open]);

	return !(isLgUp && variant == 'permanent') ? (
		<SwipeableDrawer
			classes={{
				root: clsx('FusePageSimple-sidebarWrapper absolute', variant),
				paper: clsx(
					'FusePageSimple-sidebar',
					variant,
					position === 'left' ? 'FusePageSimple-leftSidebar' : 'FusePageSimple-rightSidebar'
				)
			}}
			sx={{
				'& .MuiPaper-root': {
					width: sidebarWidth,
					maxWidth: '100%'
				}
			}}
			variant="temporary"
			anchor={position}
			open={isOpen}
			onOpen={ev => {}}
			onClose={() => (onClose ? onClose() : undefined)}
			disableSwipeToOpen
			ModalProps={{
				keepMounted: true // Better open performance on mobile.
			}}
			slotProps={{
				backdrop: {
					classes: {
						root: 'FusePageSimple-backdrop'
					}
				}
			}}
		>
			<FusePageSimpleSidebarContent {...props} />
		</SwipeableDrawer>
	) : (
		<Drawer
			className={clsx(
				'FusePageSimple-sidebarWrapper',
				variant,
				isOpen ? 'opened' : 'closed',
				position === 'left' ? 'FusePageSimple-leftSidebar' : 'FusePageSimple-rightSidebar'
			)}
			classes={{
				paper: clsx('FusePageSimple-sidebar border-0', variant)
			}}
			variant="permanent"
			anchor={position}
			open={isOpen}
			onClose={onClose}
		>
			<FusePageSimpleSidebarContent {...props} />
		</Drawer>
	);
});

export default FusePageSimpleSidebar;
